import { Pipe, PipeTransform } from '@angular/core';
import { FooterLayoutType } from '@shared/enums/FooterLayoutType';

@Pipe({
    name: 'columnWidth'
})
export class ColumnWidthPipe implements PipeTransform {
    transform(footerLayoutType: FooterLayoutType, index: number): string {
        let width = '100%';

        switch (footerLayoutType) {
            // Single column
            case FooterLayoutType.Single:
                width = '100%';
                break;
            // Double column
            case FooterLayoutType.Double5050:
                width = '50%';
                break;
            case FooterLayoutType.Double2575:
                if (index === 0) {
                    width = '25%';
                } else {
                    width = '75%';
                }
                break;
            case FooterLayoutType.Double7525:
                if (index === 0) {
                    width = '75%';
                } else {
                    width = '25%';
                }
                break;
            // Triple column
            case FooterLayoutType.Triple333333:
                width = '33%';
                break;
            case FooterLayoutType.Triple252550:
                if (index === 2) {
                    width = '50%';
                } else {
                    width = '25%';
                }
                break;
            case FooterLayoutType.Triple255025:
                if (index === 1) {
                    width = '50%';
                } else {
                    width = '25%';
                }
                break;
            case FooterLayoutType.Triple502525:
                if (index === 0) {
                    width = '50%';
                } else {
                    width = '25%';
                }
                break;
            // Quadruple column
            case FooterLayoutType.Quadruple:
                width = '25%';
                break;
        }

        return width;
    }
}
